module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[51]416.a697466.woff2";